// Merge only the caller's parameters into the URL at write time. Next's router
// can lag behind history.replaceState, and two debounced writers may interleave.
export function patchPlanningQuery(href, updates, ownedKeys = []) {
  const url = new URL(href);
  ownedKeys.forEach(key => url.searchParams.delete(key));
  Object.entries(updates).forEach(([key, value]) => {
    if (value == null || value === '') url.searchParams.delete(key);
    else url.searchParams.set(key, String(Array.isArray(value) ? value[0] : value));
  });
  return url.pathname + url.search + url.hash;
}
